import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_MAP } from '../constants';
import { useAdUnit } from '../useAdUnit';
const DesktopAdhesion = /*#__PURE__*/ React.memo(({ safety ='unlikely'  })=>{
    useAdUnit(AdProviders.Nitro, ADUNIT_MAP['DesktopAdhesion'], safety, {
        refreshLimit: 30,
        refreshTime: 30,
        format: 'anchor',
        anchor: 'bottom',
        anchorPersistClose: false,
        report: {
            enabled: false
        },
        mediaQuery: '(min-width: 1025px), (min-width: 768px) and (max-width: 1024px), (min-width: 320px) and (max-width: 767px)'
    });
    return null; // anchors DONT need a div
}, adunitMemo);
DesktopAdhesion.displayName = 'DesktopAdhesion';
export default DesktopAdhesion;
